/**
 * Odkaz na skopírovanie / zdieľanie – aktuálna doména + štandardná cesta /openTab/.
 * @param {string} tab React page (napr. Reklamacia, PriorityList)
 * @param {Record<string, string|number|null|undefined>} params query parametre okrem tab
 */
export function buildAppOpenTabShareUrl(tab, params = {}) {
  const origin = typeof window !== 'undefined' && window.location?.origin
    ? window.location.origin
    : '';
  const page = String(tab ?? '').trim();
  if (!origin || !page) return '';
  const search = new URLSearchParams({ tab: page });
  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined || value === '') return;
    search.set(key, String(value));
  });
  return `${origin}/openTab/?${search.toString()}`;
}
